
function mixSidebarItems (base, newItems) {
  newItems.forEach(addItem => {
    const baseItem = base.find(x => x.text === addItem.text);
    if (!baseItem) {
      base.push(addItem);
      return;
    }
    if (baseItem.path) {
      console.warning(`[warning] ignoring 'path' defined for sidebar item '${baseItem.text}'. Sidebar items can have a path or children, but not both.`);
      baseItem.path = null;
    }
    baseItem.permissions ??= [];
    baseItem.permissions = baseItem.permissions.concat(addItem.permissions);
    baseItem.children ??= [];
    if (addItem.children?.length)
      mixSidebarItems(baseItem.children, addItem.children);
  });
  return base;
}



export const addSidebarItems = (baseItems) => ( newItems=[] ) => {

  if (!baseItems)
    return [];
  mixSidebarItems(baseItems, newItems);

};
